module.exports = __webpack_public_path__ + "static/media/education-object-1-1-1.373deaba.svg";